import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';
import { CardPresentationComponent } from 'app/core/components/workflow-new/common/card-presentation';
import { MaterialConfiguration } from 'app/core/components/workflow-new/material/configurations/material-configuration';
import { Observable } from 'rxjs/Observable';
import { trigger, style, state, transition, animate } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'itpx-evaluation-expandable-tile',
  templateUrl: './evaluation-expandable-tile.component.html',
  styleUrls: ['../../../workflow-new/common/style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('expandCollapse', [
      state('open', style({
        opacity: '1',
        display: 'block',
        // transform: 'translate3d(0, 0, 0)'
      })),
      state('closed', style({
        opacity: '0',
        display: 'none',
        // transform: 'translate3d(0, -100%, 0)'
      })),
      transition('closed <=> open', animate('200ms ease-in-out')),
    ]),
    trigger('roundStraight', [
      state('open', style({
        'border-bottom-left-radius': '0px',
        'border-bottom-right-radius': '0px'
      })),
      state('closed', style({
        'border-bottom-left-radius': '4px',
        'border-bottom-right-radius': '4px'
      })),
      transition('closed <=> open', animate('200ms ease-in-out')),
    ])
  ]
})
export class EvaluationExpandableTileComponent extends CardPresentationComponent implements OnInit {
  @Input() props$: Observable<any>;
  @Input() conf: MaterialConfiguration;
  @Input() state$: Observable<any>;
  @Input() tileClicked$: Observable<void>;
  @Input() assignmentId:string;
  private sharedState$: Observable<any>;
  private tagType: string;
  private expired: boolean;
  private supplements: string;
  private imageWidth: string;
  private imageHeight: string;
  private cardHeight: string;
  private cardWidth: string;
  private thumbnail: string;
  private readonly downloadableMaterial: string[] = ['ebook', 'ispring', 'archive'];
  private completedCourses: number;
  private totalCourses: number = 1;
  private openCloseAnim: string;
  private changeText$ = new Subject<any>();
  private properties: any;

  constructor(private router: Router, private route: ActivatedRoute,  private detector: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.openCloseAnim = 'closed';
    this.sharedState$ = this.state$.shareReplay(1);
    Object.assign(this, this.conf);
    this.props$.bindToLifecycle(this).subscribe(props => {
      this.completedCourses = props.contents.filter(content => content.coursePercentage === 100).length;
      this.totalCourses = props.contents.length;
      this.properties = props;
      if (this.conf.multiContent) {
        this.conf.links = [{
          disabled: false,
          tooltip: null,
          url: [],
          text: 'branded.portal.courses.assignment.showAll',
          type: LinkActions.EXPAND,
        }];
      } else {
        throw new Error('Expecting a multi content deliverable here');
      }
      // this.detector.detectChanges();
    });
    this.sharedState$.bindToLifecycle(this).subscribe(res => {
      this.conf.clickable = res.enabled;
      if (this.downloadableMaterial.includes(res.type.toLowerCase()) && res.googleEmbedLink)
        this.conf.links[0].url = [res.googleEmbedLink];
    });
    
    

    this.tileClicked$.bindToLifecycle(this).subscribe(_ => {this.onExpandClicked(); this.detector.detectChanges();});
  }

  onExpandClicked() {
    this.openCloseAnim = (this.openCloseAnim == 'open') ? 'closed' : 'open';
    
    this.conf.links[0].text = (this.openCloseAnim == 'open') ? 'branded.portal.courses.assignment.hideAll' :
      'branded.portal.courses.assignment.showAll';
    this.changeText$.next({});
  }

  trackByFn(index, item) {
    return index; // or item.id
  }

  onClick(index: number) {
    if ('scormcloud' === this.properties.type) {
    this.router.navigate(['evaluation', this.properties.type, this.properties.contents[index].scormCloudTokenId]);
    } else {
      this.router.navigate(['evaluation', this.properties.type, this.assignmentId, this.properties.contents[index].id]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/workflow_new/evaluation-expandable-tile/evaluation-expandable-tile.component.ts